import api from "../../api";
import { apiError } from "../../models";
import {
  FETCH_PLAN_MERCHANTS_LOADING,
  FETCH_PLAN_MERCHANTS_SUCCESS,
  FETCH_PLAN_MERCHANTS_FAILED,
} from "../types";
import { recurringPlanGetMerchantsEndpoint } from "../../api/apisUrl";

export const fetchMerchants =
  (
    planId: string,
    token: string,
    pageNumber = 1,
    pageLength = 25,
    merchantName = ""
  ) =>
  async (dispatch: any) => {
    dispatch({ type: FETCH_PLAN_MERCHANTS_LOADING });

    try {
      const params = new URLSearchParams();

      if (planId) params.append("planId", planId);
      if (merchantName) params.append("merchantName", merchantName);
      params.append("pageNumber", pageNumber.toString());
      params.append("pageLength", pageLength.toString());

      const url = `${recurringPlanGetMerchantsEndpoint()}?${params.toString()}`;

      const response = await api.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: FETCH_PLAN_MERCHANTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      apiError(
        FETCH_PLAN_MERCHANTS_LOADING,
        FETCH_PLAN_MERCHANTS_FAILED,
        error,
        dispatch
      );
    }
  };
